var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 383.859,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 127.86
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.281,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 255.72
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 127.86
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M246.789,305.224l64.48-55.268v79.987c0,13.48-10.928,24.409-24.409,24.409l0,0  c-6.03,0-11.846-2.232-16.328-6.266l-23.743-21.368L246.789,305.224L246.789,305.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M280.801,336.674l-18.66-16.794v-27.815l33.775-28.951v20.22v46.608c0,4.994-4.063,9.056-9.056,9.056  C284.619,338.999,282.467,338.174,280.801,336.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M271.352,284.17v31.617l15.352,13.861v-46.505v-12.132l9.211-7.896v20.22v46.608  c0,4.994-4.063,9.056-9.056,9.056c-2.241,0-4.393-0.826-6.059-2.325l-18.66-16.794v-27.815L271.352,284.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M265.211,305.224l-64.48-55.268v79.987c0,13.48,10.928,24.409,24.409,24.409l0,0  c6.03,0,11.846-2.232,16.328-6.266l23.743-21.368V305.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M231.199,336.674l18.66-16.794v-27.815l-33.775-28.951v20.22v46.608c0,4.994,4.063,9.056,9.056,9.056  C227.381,338.999,229.533,338.174,231.199,336.674z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M240.648,284.17v31.617l-15.352,13.861v-46.505v-12.132l-9.211-7.896v20.22v46.608   c0,4.994,4.063,9.056,9.056,9.056c2.241,0,4.393-0.826,6.059-2.325l18.66-16.794v-27.815L240.648,284.17z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.04,
    y: 250.23,
    style: {
      fill: "#41479B"
    },
    width: 4.414,
    height: 26.448
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.51,
    y: 250.23,
    style: {
      fill: "#41479B"
    },
    width: 4.414,
    height: 26.448
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4646"
    },
    d: "M246.789,237.674c0,0,6.141-29.169-15.352-25.331c-21.493,3.838-21.493,9.979-46.057,22.261   c0,0,27.634,6.141,39.916,3.07c0,0,9.211,12.282,18.423,15.352h9.211L246.789,237.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4646"
    },
    d: "M265.211,237.674c0,0-6.141-29.169,15.352-25.331c21.493,3.838,21.493,9.979,46.057,22.261   c0,0-27.634,6.141-39.916,3.07c0,0-9.211,12.282-18.423,15.352h-9.211L265.211,237.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4646"
    },
    d: "M265.211,253.026h-18.423V237.56c0-5.025,4.073-9.098,9.098-9.098h0.227   c5.025,0,9.098,4.073,9.098,9.098L265.211,253.026L265.211,253.026z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E1CD"
    },
    cx: 256,
    cy: 237.67,
    r: 6.141
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD0AF"
    },
    d: "M242.823,233.708l11.547,6.166c0.969,0.517,2.161,0.34,2.938-0.436l0,0  c0.974-0.974,0.974-2.553,0-3.527l-7.448-7.448h-1.791C245.171,228.463,242.823,230.811,242.823,233.708L242.823,233.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF94"
    },
    d: "M246.827,234.604h-9.249l4.048-4.739c0.76-0.89,1.872-1.402,3.042-1.402h5.192v3.109  C249.859,233.246,248.501,234.604,246.827,234.604z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB400"
    },
    d: "M282.186,253.034c-2.072-2.459-2.513-5.717-1.504-8.541c2.954-0.516,6.091,0.472,8.162,2.93   c1.77,2.1,2.283,4.773,1.784,7.271c0.613,1.042,1.364,2.382,2.189,3.963c0.041-0.225,0.032-0.448,0.096-0.673   c0.724-2.545,2.743-4.347,5.135-4.958c1.712,1.778,2.483,4.373,1.759,6.918c-0.623,2.19-2.227,3.777-4.18,4.581   c0.771,1.768,1.534,3.676,2.246,5.69c0.041-0.118,0.044-0.238,0.091-0.355c1-2.451,3.206-4.019,5.65-4.362   c1.506,1.955,1.986,4.62,0.986,7.069c-0.875,2.144-2.69,3.558-4.763,4.121c1.068,4.213,1.776,8.683,1.776,13.183h-3.07   c0-3.921-0.602-7.85-1.51-11.608c-1.895,0.612-4.012,0.482-5.844-0.641c-2.236-1.37-3.416-3.778-3.361-6.223   c2.153-1.16,4.835-1.202,7.071,0.168c0.08,0.049,0.135,0.121,0.213,0.174c-0.657-1.89-1.358-3.684-2.076-5.365   c-1.843,0.871-4.012,1.005-6.001,0.07c-2.373-1.115-3.812-3.379-4.026-5.815c2.006-1.386,4.656-1.722,7.024-0.62   c-0.846-1.626-1.608-2.985-2.205-4.002C285.707,255.77,283.67,254.796,282.186,253.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB400"
    },
    d: "M229.814,253.034c2.072-2.459,2.513-5.717,1.504-8.541c-2.954-0.516-6.091,0.472-8.162,2.93   c-1.77,2.1-2.283,4.773-1.784,7.271c-0.613,1.042-1.364,2.382-2.189,3.963c-0.041-0.225-0.032-0.448-0.096-0.673   c-0.724-2.545-2.743-4.347-5.135-4.958c-1.712,1.778-2.483,4.373-1.759,6.918c0.623,2.19,2.227,3.777,4.18,4.581   c-0.771,1.768-1.534,3.676-2.246,5.69c-0.041-0.118-0.044-0.238-0.091-0.355c-1-2.451-3.206-4.019-5.65-4.362   c-1.506,1.955-1.986,4.62-0.986,7.069c0.875,2.144,2.69,3.558,4.763,4.121c-1.068,4.213-1.776,8.683-1.776,13.183h3.07   c0-3.921,0.602-7.85,1.51-11.608c1.895,0.612,4.012,0.482,5.844-0.641c2.236-1.37,3.416-3.778,3.361-6.223   c-2.153-1.16-4.835-1.202-7.071,0.168c-0.08,0.049-0.135,0.121-0.213,0.174c0.657-1.89,1.358-3.684,2.076-5.365   c1.843,0.871,4.012,1.005,6.001,0.07c2.373-1.115,3.812-3.379,4.026-5.815c-2.006-1.386-4.656-1.722-7.024-0.62   c0.846-1.626,1.608-2.985,2.205-4.002C226.293,255.77,228.33,254.796,229.814,253.034z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,320.577l-64.48-55.268v79.987c0,13.48,10.928,24.409,24.409,24.409l0,0  c6.03,0,11.846-2.232,16.328-6.266L256,342.07V320.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M221.987,352.027l18.66-16.794v-27.815l-33.775-28.951v20.22v46.608c0,4.994,4.063,9.056,9.056,9.056  C218.17,354.352,220.322,353.526,221.987,352.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M231.436,299.522v31.617L216.084,345v-46.505v-12.132l-9.211-7.896v20.22v46.608  c0,4.994,4.063,9.056,9.056,9.056c2.241,0,4.393-0.826,6.059-2.325l18.66-16.794v-27.815L231.436,299.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,320.577l64.48-55.268v79.987c0,13.48-10.928,24.409-24.409,24.409l0,0  c-6.03,0-11.846-2.232-16.328-6.266L256,342.07V320.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M290.013,352.027l-18.66-16.794v-27.815l33.775-28.951v20.22v46.608c0,4.994-4.063,9.056-9.056,9.056  C293.83,354.352,291.678,353.526,290.013,352.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M280.564,299.522v31.617L295.916,345v-46.505v-12.132l9.211-7.896v20.22v46.608  c0,4.994-4.063,9.056-9.056,9.056c-2.241,0-4.393-0.826-6.059-2.325l-18.66-16.794v-27.815L280.564,299.522z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#69C3FF"
    },
    cx: 256,
    cy: 299.079,
    rx: 30.705,
    ry: 46.06
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009B64"
    },
    d: "M228.366,311.365h55.268l3.07-12.282l-13.993,2.332c-2.808,0.468-5.678-0.332-7.839-2.184  l-15.884-13.615c-1.419-1.217-3.227-1.885-5.097-1.885l0,0c-2.077,0-4.069,0.825-5.538,2.294l-9.988,9.988L228.366,311.365  L228.366,311.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M253.087,297.021l5.275-3.37l-9.374-8.034c-1.419-1.217-3.227-1.885-5.097-1.885l0,0  c-2.077,0-4.069,0.825-5.538,2.294l-9.988,9.988v3.07l15.352-3.07l2.715,1.357C248.558,298.433,251.085,298.299,253.087,297.021z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5AA0E6"
    },
    points: "228.366,311.365 231.436,329.788 246.789,345.14 256,345.14 268.282,342.07 280.564,329.788   283.634,311.365 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC88C"
    },
    d: "M256,348.211c-18.624,0-33.775-22.039-33.775-49.127s15.151-49.127,33.775-49.127  s33.775,22.039,33.775,49.127S274.624,348.211,256,348.211z M256,256.096c-15.237,0-27.634,19.283-27.634,42.986  s12.397,42.987,27.634,42.987s27.634-19.283,27.634-42.987C283.634,275.38,271.237,256.096,256,256.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E1E1"
    },
    d: "M234.339,344.865c-2.575-3.554-6.406-5.865-10.747-5.865s-8.172,2.311-10.747,5.865   c4.39,1.217,7.982,4.781,9.683,9.479c0.685,1.892,1.063,3.968,1.063,6.149C223.592,352.897,228.182,346.571,234.339,344.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E1E1"
    },
    d: "M226.031,354.552c0,0-0.24,4.094-2.339,6.013l-0.088-0.072c-2.099-1.919-2.339-6.013-2.339-6.013   L226.031,354.552z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M294.4,355.887h-76.8c-0.837,0-1.516-0.679-1.516-1.516v-0.038c0-0.837,0.679-1.516,1.516-1.516h76.8  c0.837,0,1.516,0.679,1.516,1.516v0.038C295.916,355.208,295.237,355.887,294.4,355.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE915A"
    },
    d: "M271.428,360.493h-30.856c-3.35,0-6.065-2.716-6.065-6.065v-0.151c0-3.35,2.716-6.065,6.065-6.065  h30.856c3.35,0,6.065,2.716,6.065,6.065v0.151C277.493,357.777,274.778,360.493,271.428,360.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M228.366,352.816h-10.747c-0.848,0-1.535,0.687-1.535,1.535s0.687,1.535,1.535,1.535h10.747V352.816z  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,360.493 256,388.546 243.718,385.056 249.859,360.493 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "252.93,360.493 246.789,381.986 234.507,378.915 243.718,360.493 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "240.648,360.493 231.436,372.775 240.648,375.845 246.789,360.493 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,360.493 256,388.546 268.282,385.056 262.141,360.493 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "259.07,360.493 265.211,381.986 277.493,378.915 268.282,360.493 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "271.352,360.493 280.564,372.775 271.352,375.845 265.211,360.493 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "193.728,291.753 189.315,287.305 189.315,265.305 193.728,265.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "322.647,287.305 318.233,291.753 318.233,265.305 322.647,265.305  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.96578507aea17a46a0720714c653e2df.svg";
export { ForwardRef as ReactComponent };